import { config } from "config";

export const GLOBAL_ACCOUNT_URLS = {
  PANEL_INVITATIONS: `${config.globalAccounts}/panel/settings/invitations`,
};
